import { ShaderProgram } from "../programs/ShaderProgram";

class ShaderPass {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initialize(program: ShaderProgram) {}
    render() {}
    dispose() {}
}

export { ShaderPass };
